import React, { useState } from 'react';
import Button from '../common/Button';
import { Modal } from '../common/Modal';
import SupplierProductSearchSelect from '../common/SearchSelect/SupplierProduct_SearchSelect';

interface AddProductModalProps {
  onClose: () => void;
  onAdd: (supplierProductId: string) => void;
}

const AddProductModal: React.FC<AddProductModalProps> = ({ onClose, onAdd }) => {
  const [selectedSupplierProduct, setSelectedSupplierProduct] = useState<{ value: string, label: string } | null>(null);

  return (
    <Modal onClose={onClose} title="Add Product to Shipment">
      <div className="p-6">
        <div className="mb-4">
          <SupplierProductSearchSelect
            supplierType="FR_ilyes"
            selectedSupplierProduct={selectedSupplierProduct}
            onSupplierProductChange={setSelectedSupplierProduct}
          />
        </div>

        <div className="mb-4 text-sm text-gray-600">
          <p>
            Note: Product search integration is pending. For now, please enter the Supplier Product
            ID manually.
          </p>
        </div>

        <div className="flex justify-end gap-2">
          <Button preset="white" onClick={onClose}>
            Cancel
          </Button>
          <Button preset="primary" onClick={() => onAdd(selectedSupplierProduct?.value || '')} disabled={!selectedSupplierProduct}>Add Product</Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddProductModal;

